import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const RedoMarketPlacementSchema_ = z.object({
  /** Markets with an active Redo option covering every active location. */
  marketsWithRedo: z.array(z.string()),
  /**
   * Markets whose Redo option covers only some active locations. A carrier
   * write cannot fix these; the option must be deleted and placed again.
   */
  marketsRedoOnSomeOrigins: z.array(z.string()),
  /** Markets that define their own shipping but carry no active Redo option. */
  marketsMissingRedo: z.array(z.string()),
  /**
   * Markets with no shipping of their own. A sub-market here takes its
   * parent's options, Redo included.
   */
  marketsInheriting: z.array(z.string()),
  /** Markets set to "Not shipping". Nothing is offered until reopened. */
  marketsNotShipping: z.array(z.string()),
});
export const RedoMarketPlacementSchema: z.ZodType<RedoMarketPlacementSchema> =
  RedoMarketPlacementSchema_;
export interface RedoMarketPlacementSchema extends z.infer<
  typeof RedoMarketPlacementSchema_
> {}

/**
 * Read-only: where Redo sits on a migrated shop's markets right now. Only
 * valid on shops with market-driven shipping.
 */
export const getRedoMarketPlacement = {
  name: "getRedoMarketPlacement" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.union([
    z.object({ carrierInstalled: z.literal(false) }),
    z.object({
      carrierInstalled: z.literal(true),
      placement: RedoMarketPlacementSchema,
    }),
  ]),
};
